import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogService, FilterPipe, MAT_ICON, TOAST_STATE, ToastmessageService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { Observable, switchMap, throwError } from 'rxjs';
import { UploadFileResponse } from '../../products/product-form/use-cases/update-product/upload-file.response';
import { GetProductsResponse } from '../../products/product-list/get-products.response';
import { Material } from '../../products/product-list/material.model';
import { Package } from '../package';
import { PackageProduct } from '../packageproduct';
import { AddpackagepriceDialogComponent } from './addpackagepricedialog/addpackagepricedialog.component';
import { AddPackagepriceDialogResult } from './addpackagepricedialog/addpackagepricedialogresult';
import { AddPackagePriceRequest } from './addpackagepricedialog/addpackagepricerequest';
import { AddPackageRequest } from './addpackagerequest';
import { PackageWithProductMapping } from './packagewithproductmapping';
@Component({
    selector: 'app-addpackage',
    templateUrl: './addpackage.component.html',
    styleUrls: ['./addpackage.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, FormsModule, MatIconModule, CommonModule, DragDropModule, FilterPipe, RouterModule, TranslationPipe]
})
export class AddpackageComponent implements OnInit {
    addCoverFile = false;
    addPackageRequest: AddPackageRequest = {};
    addPackageUrl = '/admin/addpackage';
    downloadUri = '';
    errorMessage = 'Kérem töltse fel a borítóképet és fülszöveget a termék hozzáadása előtt!';
    file: File | null = null;
    fileBaseUrl = '';
    fileCover: File | null = null;
    @ViewChild('fileCoverInput') fileCoverInput!: ElementRef;
    filteredBooks: Material[] = [];
    getProductsUrl = '/store/get-products';
    maxFileSize = 5000000;
    package: Package = {};
    packageForm?: FormGroup;
    packageProductList: Material[] = [];
    products: Material[] = [];
    searchText = '';
    storeBaseUrl = '';
    sum = 0;
    uploadFileResponse: UploadFileResponse = {};
    uploadFileUrl = '/admin/uploadFile';
    addPackagePriceUrl = '/admin/add-package-price';
    url = '';

    private _dialogService = inject(DialogService);

    constructor(
        public _router: Router,
        private _fb: FormBuilder,
        private _toastMessageService: ToastmessageService,
        @Inject('FILE_MANAGER_URL') private _fileManagerUrl: string,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _translateService: TranslationService
    ) {
        this.fileBaseUrl = _fileManagerUrl;
        this.storeBaseUrl = _storeBaseUrl;
        this.createPPackageForm();
    }

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        }
        if (sessionStorage.getItem('product')) {
            const product = JSON.parse(sessionStorage.getItem('product') as string) as Material;
            const index = this.products.indexOf(product);
            this.products.splice(index, 1);
            this.packageProductList.push(product);
            sessionStorage.removeItem('product');
        }
        this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.getProductsUrl).subscribe((response) => {
            const products = response as GetProductsResponse;
            this.products = products.productList as Material[];
            this.filteredBooks = this.products;
        });
    }

    createPPackageForm() {
        this.packageForm = this._fb.group({
            packageName: ['', [Validators.required]],
            imageUrl: ['', [Validators.required]]
        });
    }

    onChange(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileCover = target.files![0];
        if (this.fileCover.name.split('.').pop() === 'png') {
            this.addCoverFile = true;
        } else {
            this.addCoverFile = false;
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem ".png" kiterjesztésű fájlt töltsön fel!',
                MAT_ICON.warning
            );
            this.dismissError();
        }
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    private dismissErrorFiveSeconds(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 5000);
    }

    collectPackageData() {
        this.package.packageName = this.packageForm?.controls['packageName'].value as string | undefined;

        if (this.downloadUri) {
            this.package.imageUrl = this.downloadUri;
        }
    }

    clearSelectedCoverFile() {
        this.fileCoverInput.nativeElement.value = null;
        this.addCoverFile = false;
    }

    addProductToPackage(product: Material) {
        this.sum += product.packagePrice!;
        if (!product.packagePrice) {
            this.openAddPackagePriceDialog(product);
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('Kérem adja meg a csomagárat a ' + product.author + ':' + product.title + ' könyvhöz!'),
                MAT_ICON.error
            );
            this.dismissErrorFiveSeconds();
        } else {
            const index = this.products.indexOf(product);
            this.products.splice(index, 1);
            this.packageProductList.push(product);
        }
    }

    deleteFromPackageProductList(product: Material) {
        this.sum -= product.packagePrice!;
        const index = this.packageProductList.indexOf(product);
        this.packageProductList.splice(index, 1);
        this.products.push(product);
    }

    openAddPackagePriceDialog(product: Material) {
        this._dialogService.openDialog(
            AddpackagepriceDialogComponent,
            null,
            ((addPackagepriceDialogResult: AddPackagepriceDialogResult | undefined) => {
                this.addPackagePrice(product, addPackagepriceDialogResult?.packagePrice!);

            }
            )
        );
    }

    addPackagePrice(product: Material, packagePrice: number) {
        const addPackagePriceRequest: AddPackagePriceRequest = {
            packagePrice: packagePrice,
            productId: product.id
        };

        this._apiRequestService
            .sendRequest<
                AddPackagePriceRequest,
                HttpResponse<any>
            >(this.storeBaseUrl, addPackagePriceRequest, true, this.addPackagePriceUrl, true)
            .subscribe(() => {
                const index = this.products.indexOf(product);
                this.products.splice(index, 1);
                this.packageProductList.push(product);
            });
    }

    drop(event: CdkDragDrop<PackageProduct[]>): void {
        moveItemInArray(this.packageProductList, event.previousIndex, event.currentIndex);
    }

    addPackage() {
        if (!this.addCoverFile) {
            this._toastMessageService.displayToastMessage(TOAST_STATE.warning, 'Kérem válassza ki a borítóképet!', MAT_ICON.warning);
            this.dismissError();
            return;
        }

        if (this.packageProductList.length === 0) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.warning,
                'Kérem adjon hozzá könyveket a csomaghoz!!',
                MAT_ICON.warning
            );
            this.dismissError();
            return;
        }

        if (this.fileCover && this.fileCover.size > this.maxFileSize) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('A maximum fájl korlát 5MB. Kérem ennél kisebb méretű fájlt töltsön fel!'),
                MAT_ICON.error
            );
            this.dismissError();
            return;
        }

        this._uploadFileObservable()
            .pipe(
                switchMap((uploadResponse: UploadFileResponse) => {
                    this.downloadUri = uploadResponse.downloadUri as string;
                    this.addCoverFile = false;

                    return this._addPackageObject();
                })
            )
            .subscribe(() => {
                this.clearSelectedCoverFile();
                this._router.navigateByUrl('/packages');
            });
    }

    private _addPackageObject() {
        this.collectPackageData();
        this.package.imageUrl = this.downloadUri;

        const packageProductList: PackageProduct[] = this.packageProductList.map((product, index) => {
            const packageProduct = new PackageProduct();
            packageProduct.product = product;
            packageProduct.packageObject = this.package;
            packageProduct.orderNumber = index;
            return packageProduct;
        });

        const packageWithProductMapping: PackageWithProductMapping = {
            packageDTO: this.package,
            packageProductList: packageProductList
        };

        const addPackageRequest: AddPackageRequest = {
            packageWithProductMappings: packageWithProductMapping
        };
        return this._apiRequestService.sendRequest<AddPackageRequest, HttpResponse<any>>(
            this.storeBaseUrl,
            addPackageRequest,
            true,
            this.addPackageUrl,
            true
        );
    }

    private _uploadFileObservable(): Observable<UploadFileResponse> {
        if (!this.fileCover) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('Kérem válassza ki a csomag borítóképét!'),
                MAT_ICON.error
            );
            this.dismissError();
            return throwError(() => new Error('File cover is missing.'));
        }
        return this._apiRequestService.uploadFile(this.fileCover, true, this.fileBaseUrl, this.uploadFileUrl);
    }
}
